import { cn, memoClassNames } from '@/utils';

export type ToolbarProps = React.ComponentProps<'div'>;

const classes = memoClassNames('Toolbar', ['root', 'title']);

export const Toolbar = ({ className, ...others }: ToolbarProps) => {
  return (
    <div
      {...others}
      className={cn(
        classes.root,
        'mm:flex mm:items-center mm:gap-2',
        className
      )}
    />
  );
};
Toolbar.displayName = 'Toolbar';

export const ToolbarTitle = ({ className, ...others }: ToolbarProps) => {
  return (
    <div
      {...others}
      className={cn(
        classes.title,
        'mm:text-sm mm:font-medium mm:grow mm:truncate',
        className
      )}
    />
  );
};

ToolbarTitle.displayName = 'ToolbarTitle';
